// extracted by mini-css-extract-plugin
export default {"AssignChecklist":"StaffClientsModal_AssignChecklist__n-wes","modalBody":"StaffClientsModal_modalBody__7HmE5","formControl":"StaffClientsModal_formControl__iUdoT"};